module.exports = __webpack_public_path__ + "img/stock3.0b76d409.png";